export default {
	"perforMeet": {
		"pickMeet": "การจองเพื่อรับสินค้า",
		"prebookStatus": "สถานะการจอง",
		"senderAddress": "ที่อยู่รับสินค้า",
		"receiverAddress": "ที่อยู่จัดส่งสินค้า",
		"latestDeliveryDt": "กำหนดเวลารับสินค้า",
		"latestReceivedDt": "กำหนดเวลาจัดส่งสินค้า",
		"orderAttachment": "เอกสารแนบคำสั่ง",
		"togetherMeetTips": "จะนัดรับคำสั่งที่มีที่อยู่รับสินค้าเดียวกันหรือไม่",
		"pickUpVehicleInfo": "ข้อมูลยานพาหนะที่รับสินค้า",
		"batchPickMeet": "การนัดหมายรับสินค้าแบบกลุ่ม",
		"batchMeet": "การนัดหมายแบบกลุ่ม",
		"batchPickMeetFail": "การจองการรับสินค้าเป็นกลุ่มไม่สำเร็จ",
		"meetFailMsg": "ข้อมูลการนัดหมายที่ไม่สำเร็จ",
		"transportPickAddress": "ที่อยู่รับสินค้า",
		"transportReceiverAddress": "ที่อยู่รับ",
		"meetPickTimeTips": "กรุณาเลือกช่วงเวลาจัดส่ง!",
		"pleaseSelectNoPickedTips": "กรุณาเลือกคำสั่งที่ต้องการรับ",
		"meetPickTimeRangeTips": "กรุณาเลือกช่วงเวลาของการนัดหมาย!",
		"msgTips": "กรุณาตรวจสอบข้อมูลการนัดรับอีกครั้ง",
		"carrierNo": "หมายเลขคำสั่งของผู้ให้บริการขนส่ง",
		"items": "โครงการ",
		"sendTime": "เวลาจัดส่งสินค้า"
	},
	"performGoods": {
		"batchPick": "การรับสินค้าแบบกลุ่ม",
		"waitingForPickUp": "จะมารับสินค้า",
		"shipped": "ส่งแล้ว",
		"pickUpFailed": "รับสินค้าไม่สำเร็จ",
		"driverHandle": "การดำเนินงานของพนักงานขับรถ",
		"pickUp": "รับสินค้าแล้ว",
		"delivered": "จัดส่งแล้ว",
		"rePickup": "รับสินค้าอีกครั้ง",
		"pickupCompleted": "รับสินค้าเสร็จสมบูรณ์",
		"doBlank": "ว่างเปล่า",
		"pickupGoodsTemp": "อุณหภูมิสินค้าขณะรับ",
		"weight": "น้ำหนักที่จะรับ (กก.)",
		"goodsQty": "จำนวนของสินค้าที่ควรได้รับ",
		"volume": "ปริมาณที่จะรับ (ลูกบาศก์เมตร)",
		"packingQty": "บรรจุภัณฑ์ที่จะรับ (กก.)",
		"actualWeight": "น้ำหนักสินค้าที่รับตามจริง",
		"actualVolume": "ปริมาณการรับสินค้าตามจริง",
		"inputPickupInfo": "บันทึกรายละเอียดการรับสินค้า",
		"pickupService": "บริการรับส่งสินค้า",
		"allPackingQty": "จำนวนกล่องทั้งหมด",
		"trackStatus": "ติดตามสถานะ",
		"thisOrderCreate": "จัดทำคำสั่งนี้แล้ว",
		"abnormalNo": "ข้อยกเว้น",
		"pleaseHandleItInTime": "กรุณาจัดการตามกำหนดเวลา",
		"isBatchPick": "รับสินค้าแบบกลุ่มต่อไปหรือไม่?",
		"batchPickTips": "กำลังประมวลผล ท่านจะได้รับแจ้งข้อมูลจากระบบหลังจากการประมวลผลเสร็จสิ้น ในระหว่างนี้ ห้ามอัพเดตสถานะการรับ/การจัดส่งสินค้าสำหรับคำสั่งซื้อ!",
		"pickupDtTips1": "เวลารับสินค้าเสร็จสมบูรณ์ต้องไม่เร็วกว่า [ เวลามาถึงเพื่อรับสินค้า เวลาเริ่มรับสินค้า]",
		"pickupDtTips2": "เวลาเริ่มรับสินค้าต้องไม่เร็วกว่า [เวลามาถึงเพื่อรับสินค้า] หรือช้ากว่า [เวลารับสินค้าเสร็จสมบูรณ์]",
		"pickupDtTips3": "เวลามาถึงเพื่อรับสินค้าต้องไม่เร็วกว่า [เวลาเริ่มรับสินค้า, เวลารับสินค้าเสร็จสมบูรณ์]",
		"notOnlyOneTips": "กรุณาเลือกคำสั่งขนส่งอย่างน้อยสองรายการ",
		"waybillStatusRequire": "สถานะของการขนส่งจะต้องเป็นสถานะการจัดส่ง",
		"laterThanTips": "ยืนยันว่าการจัดส่งเสร็จสมบูรณ์ไม่เกิน..",
		"endTimeTips": "จุดสิ้นสุดของการขนส่ง?",
		"pickupArrivalDtTips": "กรุณากรอกเวลารับสินค้า",
		"overPickupArrivalDtTips": "เวลามาถึงเพื่อรับสินค้าต้องมาก่อนเวลาปัจจุบัน",
		"inputCapacityInfoTips": "กรุณากรอกข้อมูลขีดความสามารถ",
		"isSureTips": "ท่านแน่ใจว่าจะ.....",
		"emptyTheWaybillTips": "ลบคำสั่งขนส่ง",
		"vehicleTemperatureTips": "กรุณากรอกตัวเลขระหว่าง -100 ถึง 100",
		"sureToSubmit": "ท่านแน่ใจว่าจะยื่นหรือไม่?",
		"selectServiceProvider": "เลือกผู้ให้บริการที่ให้บริการเพิ่มเสริม",
		"serviceProvider": "ผู้ให้บริการ",
		"serviceWorkload": "กรอกบริการเพิ่มเสริม",
		"baseService": "บริการพื้นฐาน",
		"selectTheServiceProvider": "เลือกผู้ให้บริการ",
		"service": "บริการ",
		"inputServiceWorkload": "กรอกจำนวนค่าบริการที่จัดหา",
		"noServiceInfo": "ยังไม่มีข้อมูลบริการ",
		"addedServiceTips": "มีข้อผิดพลาดในบริการเพิ่มมูลค่า กรุณาแก้ไขให้ถูกต้อง!",
		"baseServiceTips": "มีข้อผิดพลาดในบริการพื้นฐาน กรุณาแก้ไขให้ถูกต้อง!"
	},
	"performSendGoods": {
		"batchSendGoods": "การจัดส่งแบบเทกอง",
		"sendGoodsfaile": "จัดส่งไม่สำเร็จ",
		"sendGoodsComplete": "จัดส่งเสร็จสมบูรณ์",
		"refused": "ปฏิเสธ",
		"latestReceivedDt": "เวลาที่คาดว่าจะมาถึง",
		"actualGoodsQty": "จำนวนสินค้าที่ได้รับ",
		"inputGoodsInfo": "กรอกรายละเอียดของสินค้าที่ลงนาม",
		"deliveryRemarks": "หมายเหตุการจัดส่งสินค้า",
		"returnTransport": "ส่งคืนสินค้า",
		"returnOfGoodsTransport": "ส่งคืน",
		"returnOfGoodsAddress": "ที่อยู่ส่งคืน",
		"returnCargoTemperature": "อุณหภูมิสินค้าส่งคืน",
		"tips1": "ส่งคืนสินค้าที่ถูกปฏิเสธไปยังที่อยู่ที่กำหนดด้วยยานพาหนะที่ได้รับมอบหมาย",
		"returnTransportCarInfo": "กรอกข้อมูลยานพาหนะขนส่งสินค้าส่งคืน",
		"tips2": "ท่านต้องการลบรายการสินค้าที่ถูกปฏิเสธหรือไม่?",
		"noReturn": "ไม่ส่งคืน",
		"batchDeliveryCompleted": "จัดส่งแบบเทกองเสร็จสมบูรณ์",
		"sendService": "จัดส่งสำเร็จ",
		"deliveryBeginDt": "เวลาเริ่มจัดส่ง",
		"rejectedGoodsStatus": "สถานะการรับ",
		"tips3": "เวลาที่จัดส่งแล้วเสร็จต้องไม่เร็วกว่า [เวลาที่มาถึงเพื่อจัดส่ง, เวลาเริ่มรับสินค้า, เวลารับสินค้าแล้วเสร็จ]",
		"tips4": "เวลาเริ่มรับสินค้าต้องไม่เร็วกว่า [เวลาที่มาถึงเพื่อจัดส่ง เวลารับสินค้าแล้วเสร็จ] หรือช้ากว่า [เวลาที่จัดส่งแล้วเสร็จ]",
		"tips5": "เวลาที่มาถึงเพื่อจัดส่งต้องไม่ช้ากว่า [เวลาเริ่มรับสินค้า เวลาที่จัดส่งแล้วเสร็จ] หรือเร็วกว่า [เวลารับสินค้าแล้วเสร็จ]",
		"successfulExecution": "ดำเนินการสำเร็จ",
		"noInfo": "ไม่มีข้อมูล",
		"tips6": "การส่งคืนสินค้า 'เวลาที่มาถึงโดยประมาณ' ต้องเป็น 'เวลาที่จัดส่งแล้วเสร็จ'",
		"tips7": "ต่อจากนั้น",
		"tips8": "ไม่อนุญาตให้ปฏิเสธใบตราส่งสินค้าหรือใบตราส่งสินค้าที่ไม่ใช่ฉบับสุดท้ายที่เกิดจากการปฏิเสธ!",
		"tips9": "ต้องกำหนดเวลาจัดส่งสินค้าแล้วเสร็จ!",
		"tips10": "อุณหภูมิสินค้าส่งคืน กรุณากรอกตัวเลขระหว่าง -100 ถึง 100 โดยมีทศนิยมสูงสุดหนึ่งตำแหน่ง",
		"tips11": "กรุณากรอกตัวเลขระหว่าง -100 ถึง 100 โดยมีจุดทศนิยมสูงสุดหนึ่งตำแหน่งสำหรับอุณหภูมิยานพาหนะ",
		"tips12": "ดำเนินการจัดส่งแบบเทกองต่อไปหรือไม่",
		"tips13": "สถานะใบตราส่งสินค้าต้องอยู่ระหว่างการขนส่ง",
		"tips14": "ยืนยันการจัดส่งแบบเทกองหรือไม่",
		"tips15": "ปริมาณสินค้าที่ถูกปฏิเสธและจำนวนบรรจุภัณฑ์ที่ถูกปฏิเสธต้องเป็น 0 สำหรับใบตราส่งสินค้าหรือใบตราส่งสินค้าที่ไม่ใช่ฉบับสุดท้ายซึ่งเกิดจากการปฏิเสธ!",
		"tips16": "กรุณากรอกน้ำหนักที่ได้รับ",
		"tips17": "กรุณากรอกตัวเลขระหว่าง -100 ถึง 100 สำหรับอุณหภูมิการจัดส่ง",
		"uncollected": "ไม่ได้จัดเก็บ",
		"partialRejection": "การปฏิเสธบางส่วน",
		"all": "จัดเก็บทั้งหมด"
	},
	"performTransit": {
		"trackingNormal": "การติดตามเป็นปกติ",
		"orderFinish": "เอกสารเสร็จสมบูรณ์",
		"transshipmentInfo": "ข้อมูลการขนถ่าย",
		"changeCarInfo": "เปลี่ยนแปลงข้อมูลยานพาหนะ",
		"changeCarTime": "เปลี่ยนแปลงเวลา",
		"mainLineDeparture": "การออกเดินทางสำหรับการขนส่งระหว่างคลังสินค้า",
		"trunkTime": "เวลาออกเดินทาง",
		"trunkArrived": "สินค้าที่ขนส่งระหว่างคลังสินค้ามาถึงแล้ว",
		"trunkArrivedTime": "เวลาที่มาถึง",
		"pickupOfArrival": "รับสินค้าที่สถานี",
		"pickupArrivalTime": "เวลาที่มาถึง",
		"distribution": "การจัดส่งสินค้าที่ขนส่งระหว่างคลังสินค้า",
		"distributionTime": "เวลาออกเดินทางสำหรับการจัดส่ง",
		"distributionCapacitys": "ข้อมูลยานพาหนะสำหรับการจัดส่ง",
		"changeCar": "เปลี่ยนแปลงยานพาหนะ",
		"transshipment": "ขนส่ง",
		"monitoringInfo": "ข้อมูลการติดตาม",
		"executeInfo": "การดำเนินการ",
		"batchCancel": "ยกเลิกสินค้าแบบเทกอง",
		"requirement": "จำเป็น",
		"project": "โครงการ",
		"packingQty": "จำนวนบรรจุภัณฑ์",
		"volume": "ปริมาณการสั่งซื้อ (ลูกบาศก์เมตร)",
		"weight": "น้ำหนักการสั่งซื้อ (กก.)",
		"realityInfo": "สถานการณ์จริง",
		"beginTime": "เวลาเริ่มต้นตามจริง",
		"endTime": "เวลาสิ้นสุดตามจริง",
		"finishLocationQty": "จำนวนสถานที่ที่จัดส่งสำเร็จ",
		"finishTransportQty": "ดำเนินการตามคำสั่งเสร็จสมบูรณ์",
		"maxTemperature": "อุณหภูมิสูงสุด",
		"mixTemperature": "อุณหภูมิต่ำสุด",
		"earliestBeginTime": "เวลาเริ่มต้นที่เร็วที่สุด",
		"latestEndTime": "เวลาสิ้นสุดล่าสุด",
		"pleaseSelectArrivedTime": "กรุณาเลือกเวลาที่มาถึง!",
		"trunkArrivedTips": "การดำเนินการนี้ใช้ได้เฉพาะกับคำสั่งการจัดส่งที่ \"อยู่ระหว่างการขนส่งตามเส้นทาง\"",
		"pleaseSelectTrunkTime": "กรุณาเลือกเวลาออกเดินทาง!",
		"trunkArrivedTips2": "การดำเนินการนี้ใช้ได้เฉพาะกับคำสั่งจัดส่งที่ \"อยู่ระหว่างการขนส่งและยังไม่ได้ออกเดินทางหรือยังมาไม่ถึง\"",
		"transportNoStatusTips": "เลือกได้เฉพาะใบตราส่งสินค้าที่มีสถานะ [ใหม่/วางแผนแล้ว/อยู่ระหว่างรอรับสินค้า]",
		"uncheckWaybill": "ท่านแน่ใจว่าต้องการยกเลิกการเลือกใบตราส่งสินค้าหรือไม่?",
		"execute": "การดำเนินการ",
		"tips1": "คำสั่ง",
		"tips2": "สำเร็จ",
		"tips3": "ไม่สำเร็จ",
		"tips4": "เหตุผลของความล้มเหลว",
		"tips5": "ผลลัพธ์ของการดำเนินการ",
		"tips6": "ใบตราส่งสินค้า",
		"tips7": "หากไม่อยู่ในสถานะจัดส่งแล้ว กรุณาตรวจสอบเอกสารในสถานะจัดส่งแล้ว",
		"tips8": "กรุณาเลือกวันที่เดินทางมาถึง",
		"tips9": "กรุณาเลือกเวลาออกเดินทางของการจัดส่งสินค้า",
		"tips10": "กรุณาเพิ่มข้อมูลรถส่งสินค้า",
		"warnTips": "คำเตือนและข้อยกเว้น",
		"warnInfo": "ข้อมูลการแจ้งเตือน",
		"warningTimeBegin": "เวลาแจ้งเตือน",
		"cancelTime": "เวลาที่อนุมัติ"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/perform/perform.js